import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useState } from "react";
import { SxProps } from "@mui/material";

import TabPanel from "../TabPanel";

type TTab = {
  disabled?: boolean;
  label: string;
  index: number;
  handleClick?: () => Promise<void>;
  children: React.ReactNode;
};

interface ITimelineProps {
  defaultTab?: number;
  tabs: TTab[];
  padding: string;
  propsTabHeader?: SxProps;
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const Timeline = ({
  defaultTab,
  tabs,
  padding,
  propsTabHeader,
}: ITimelineProps) => {
  const [value, setValue] = useState(defaultTab || 0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box padding={padding || "24px 0px 32px 0px"}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="scrollable"
        >
          {tabs.map((tab, index) => (
            <Tab
              disabled={tab.disabled}
              key={index}
              label={tab.label}
              onClick={tab.handleClick}
              sx={{
                minWidth: `${tab.label.length}px`,
                p: "8px 0px",
                marginRight: 4,
                ...propsTabHeader,
              }}
              {...a11yProps(value)}
            />
          ))}
        </Tabs>
      </Box>
      {tabs.map((tab, index) => (
        <Box key={index} marginTop={tab.index !== value ? undefined : 2}>
          <TabPanel sx={{ width: "100%" }} index={tab.index} value={value}>
            {tab.children}
          </TabPanel>
        </Box>
      ))}
    </Box>
  );
};
